module.exports = __webpack_public_path__ + "img/cgjz-2.466fa016.jpg";